import TrendArrow from './TrendArrow';

export default TrendArrow;
